// control-center/src/components/credentials/GiteaBotRow.tsx
import { useState } from 'react';
import type { GiteaBotRow as GiteaBotRowType } from '../../lib/giteaBotCredentials';
import { GiteaBotRowDetail } from './GiteaBotRowDetail';

export interface GiteaBotRowProps {
  bot: GiteaBotRowType;
  onMint: () => void;
}

function statusBadge(bot: GiteaBotRowType) {
  if (bot.drift_detected_at) {
    return <span style={{ background: '#7c2d12', color: '#fed7aa', borderRadius: 4, padding: '0.15rem 0.5rem', fontSize: '0.7rem', fontWeight: 600 }}>DRIFT</span>;
  }
  if (!bot.current_pat_name) {
    return <span style={{ background: '#1e3a5f', color: '#93c5fd', borderRadius: 4, padding: '0.15rem 0.5rem', fontSize: '0.7rem' }}>No PAT</span>;
  }
  return <span style={{ background: '#14532d', color: '#86efac', borderRadius: 4, padding: '0.15rem 0.5rem', fontSize: '0.7rem' }}>Active</span>;
}

export function GiteaBotRow({ bot, onMint }: GiteaBotRowProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <tr
        style={{ cursor: 'pointer', borderBottom: '1px solid #1e293b' }}
        onClick={() => setExpanded(e => !e)}
      >
        <td style={{ padding: '0.6rem 0.75rem', color: '#e2e8f0' }}>
          <code style={{ fontSize: '0.8rem' }}>{bot.bot_name}</code>
        </td>
        <td style={{ padding: '0.6rem 0.75rem', color: '#94a3b8', fontSize: '0.85rem' }}>{bot.consumed_by_product}</td>
        <td style={{ padding: '0.6rem 0.75rem', color: '#94a3b8', fontSize: '0.8rem' }}>{bot.scopes?.join(', ')}</td>
        <td style={{ padding: '0.6rem 0.75rem', color: '#64748b', fontSize: '0.75rem' }}>
          {bot.last_minted_at ? new Date(bot.last_minted_at).toLocaleDateString() : '—'}
        </td>
        <td style={{ padding: '0.6rem 0.75rem' }}>
          {statusBadge(bot)}
        </td>
        <td style={{ padding: '0.6rem 0.75rem' }}>
          <button
            onClick={e => { e.stopPropagation(); onMint(); }}
            style={{ background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 4, padding: '0.25rem 0.6rem', cursor: 'pointer', fontSize: '0.75rem' }}
          >
            Mint
          </button>
        </td>
      </tr>
      {expanded && (
        <tr>
          <td colSpan={6} style={{ padding: 0, background: '#0f172a' }}>
            <GiteaBotRowDetail bot={bot} onMint={onMint} />
          </td>
        </tr>
      )}
    </>
  );
}
